var _desc, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCircleIco(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "next (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Affiliate-quarter-dashboard1",
    transform: "translate(-1024.000000, -761.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(280.000000, 754.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(744.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-(2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9733968,7.63127322 L8.42379182,7.63127322 L8.42379182,4.08166822 C8.42379182,3.87674257 8.25778346,3.71073422 8.05285781,3.71073422 C7.84804833,3.71073422 7.68192381,3.87674257 7.68192381,4.08166822 L7.68192381,7.63127322 L3.95051117,7.63127322 C3.74558549,7.63127322 3.57957713,7.79739777 3.57957713,8.00220726 C3.57957713,8.20713291 3.74558549,8.37314126 3.95051117,8.37314126 L7.68564128,8.37314126 L7.68564128,12.1082714 C7.68564128,12.3130809 7.8517658,12.4792054 8.05645912,12.4792054 C8.26138474,12.4792054 8.42739313,12.3130809 8.42739313,12.1082714 L8.42739313,8.37314126 L11.9772305,8.37314126 C12.1819238,8.37209573 12.3472351,8.20515801 12.3461945,8.00034852 C12.3452602,7.7956552 12.1783225,7.63034385 11.9733968,7.63127322 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97490706,0.0275093731 C4.74941915,0.0269516729 1.84131039,1.96979554 0.606993487,4.94981413 C-0.627091093,7.92994888 0.0555297546,11.3600139 2.33701207,13.6401022 C5.45085966,16.7539498 10.4991868,16.7539498 13.6129182,13.6401022 C16.7266496,10.526487 16.7266496,5.47815985 13.6129182,2.36431227 C12.120934,0.863847584 10.0908457,0.0224209963 7.97490706,0.0275093731 Z M7.97490706,15.2351301 C3.9875697,15.2351301 0.742100372,11.9895446 0.742100372,8.00220726 C0.742100372,4.01486989 3.9875697,0.769400565 7.97490706,0.769400565 C11.9622444,0.769400565 15.2078299,4.01486989 15.2078299,8.00220726 C15.2078299,11.9895446 11.9622444,15.2351301 7.97490706,15.2351301 Z",
    id: "Shape"
  }))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIco);
export default __webpack_public_path__ + "static/media/plus-circle-ico.3c8834d15ebcb4d91f4f984c1bb8a075.svg";
export { ForwardRef as ReactComponent };